import { useTranslation } from "react-i18next";

import Select, { SelectOption } from "./Select";

export const USER_LANG_KEY = "userLang";

const LANGUAGE_OPTIONS: SelectOption<string>[] = [
  { id: "en-US", value: "English" },
  { id: "ja-JP", value: "日本語" },
];

const i18nCodeToLanguageCode = (i18nCode: string): string =>
  LANGUAGE_OPTIONS.find((lang) => lang.id.startsWith(i18nCode))?.id ||
  LANGUAGE_OPTIONS[0].id;

interface LanguageSelectProps {
  languageCode?: string;
  onChange?: (update: { language: string; languageCode: string }) => void;
  label?: string;
}

export const LanguageSelect = ({
  languageCode,
  onChange,
  label,
}: LanguageSelectProps) => {
  const { t, i18n } = useTranslation();

  const isControlled = languageCode !== undefined;
  const resolvedCode = isControlled
    ? languageCode
    : i18nCodeToLanguageCode(i18n.language);

  const currentLanguage =
    LANGUAGE_OPTIONS.find((lang) => lang.id === resolvedCode) ||
    LANGUAGE_OPTIONS[0];

  const handleLanguageChange = (option: SelectOption<string>) => {
    if (isControlled) {
      onChange?.({
        language: option.value as string,
        languageCode: option.id,
      });
    } else {
      const i18nCode = option.id.split("-")[0];
      i18n.changeLanguage(i18nCode);
      localStorage.setItem(USER_LANG_KEY, i18nCode);
    }
  };

  return (
    <Select
      options={LANGUAGE_OPTIONS}
      selected={currentLanguage}
      onSelect={handleLanguageChange}
      label={label ?? t("common:language")}
      fullWidth
      testId="language-select"
    />
  );
};
